import fetch from '../utils/fetch'

// 美洽配置
export function getMeiqiaInfo (query) {
  return fetch({
    url: '/im/meiqia',
    method: 'get',
    params: query
  })
}

export function saveMeiqia (params) {
  return fetch({
    url: '/im/meiqia',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/im.js